import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from "@angular/core";
import {DashboardModel} from "../../../models/dashboard.model";
import {WidgetModel} from "../../../models/widget.model";
import {CompactType, GridsterConfig, GridType} from 'angular-gridster2';
import {DataSourceConfigurationModel} from "../../../models/data-source-configuration.model";
import {BranchModel} from "../../../../branches/models/branch.model";
import {BranchReferenceModel} from "../../../../branches/models/branch-reference.model";

require('./dashboard-view.scss');
@Component({
  standalone: false,
  selector: 'app-dashboard-view',
  templateUrl: './dashboard-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardViewComponent implements OnInit, AfterViewInit {

  @Input() dashboard: DashboardModel;
  @Input() userBranches: BranchReferenceModel[];
  @Input() userTeams: any[];
  @Input() userBranchesIntersectionTeamMap: any;
  @Input() currentUser: any;
  @Input() dateRange: { dateStart: number, dateEnd: number };
  @Input() datasourceConfigurationsMap: any;

  @Input() isReorderWidgetsMode: boolean;
  @Output() deleteWidgetEvent = new EventEmitter<{ index: number, widget: WidgetModel }>();
  @Output() editWidgetEvent = new EventEmitter<WidgetModel>();
  @Output() updateDashboardEvent = new EventEmitter<DashboardModel>();

  @ViewChild('gridContainer', {static: true}) gridContainer: ElementRef;

  options: GridsterConfig;
  resizeObserver: any;
  canEdit: boolean;

  constructor(@Inject(Renderer2) private renderer: Renderer2) {
  }

  ngOnInit() {
    this.canEdit = this.currentUser.id === this.dashboard.ownerId;
    this.options = {
      itemChangeCallback: this.itemChange.bind(this),
      gridType: GridType.Fixed,
      compactType: CompactType.None,
      pushItems: true,
      draggable: {
        enabled: this.canEdit,
        ignoreContent: true,
        dragHandleClass: 'drag-handle',
      },
      resizable: {
        enabled: true,
        handles: {
          s: false,
          e: false,
          n: false,
          w: false,
          se: this.canEdit,
          ne: false,
          sw: this.canEdit,
          nw: false
        }
      },
      minCols: 12, // Minimum number of columns
      maxCols: 12, // Maximum number of columns (to prevent horizontal scrolling),
      minItemRows: 5,
      displayGrid: "none",
      fixedRowHeight: 25,
      margin: 10,
      scrollSensitivity: 10,
    };
  }

  ngAfterViewInit() {
    this.onResizeChange();
    this.resizeObserver = new ResizeObserver(() => {
      this.onResizeChange();
    });
    this.resizeObserver.observe(this.gridContainer.nativeElement);
  }

  itemChange(item) {
    if (!this.canEdit) {
      return;
    }
    const dashboard = {...this.dashboard};
    if (!dashboard.dashboardDesign) {
      dashboard.dashboardDesign = {}
    }

    if (!dashboard.dashboardDesign?.widgetSizeConfiguration) {
      dashboard.dashboardDesign.widgetSizeConfiguration = {}
    }
    dashboard.dashboardDesign.widgetSizeConfiguration[item.id] = item;
    this.updateDashboardEvent.emit(dashboard);
  }

  private onResizeChange() {
    this.options.fixedColWidth = this.calculateColWidth();
    this.options?.api?.optionsChanged();
  }

  private calculateColWidth() {
    const containerWidth = this.gridContainer.nativeElement.clientWidth;
    const columns = 12;
    return (containerWidth - ((this.options.margin + 2) * (columns - 1))) / columns;
  }

}
